<template>
  <div class="cover-page container-fluid">
    <div class="cover-title clearfix">
      <div class="pull-left">
        <ul class="nav nav-tabs">
          <li :class="[activeTab === tab.name ? 'active' : '', 'text-small']" @click="setActiveTab(tab)"
              v-for="(tab, index) in tabList" :key="index" role="presentation">
            <a href="javascript:;" :class="[activeTab === tab.name ? 'text-primary' : 'text-muted']">
              <i :class="['fa', `fa-${tab.icon}`]"></i>
              {{$t(tab.label)}}
            </a>
          </li>
        </ul>
      </div>
      <button class="btn primary pull-right" @click="$router.push({name: 'preview', query: $route.query})">
        <i class="fa fa-eye"></i>
        <span>{{$t('cover.tabSave')}}</span>
      </button>
    </div>
    <div class="row" v-if="dataLoaded">
      <div class="col-sm-12 col-md-6 cover-wrap">
        <swiper :options="swiperOption" ref="mySwiper" v-if="activeTab === 'insert'">
          <!-- slides -->
          <swiper-slide v-for="(page, index) in insertPages" :key="index">
            <cover-holder :src="page" :height="coverHeight"/>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
        </swiper>
        <cover-holder :src="currentImage" :height="coverHeight" v-else/>
        <div class="text-center mt-1" v-show="activeTab === 'cover'">
          <a :href="previewImage" target="_blank">
            <button class="btn default-ghost">
              {{$t('cover.viewOriginal')}}
              <i class="fa fa-external-link"></i>
            </button>
          </a>
        </div>
        <div class="text-center text-mini text-muted mt-1" v-show="activeTab === 'typeset'">
          {{$t('cover.sampleNote')}}
        </div>
      </div>
      <div class="col-sm-12 col-md-6 bg-white">
        <template v-if="activeTab === 'cover'">
          <div class="form-group">
            <label>{{$t('cover.labelBookTitle')}}（{{$t('cover.labelMaxCount', { count: 25 })}}）</label>
            <input type="text" :value="design.title" @change="changeTitle" class="form-control" maxlength="25">
          </div>
          <div class="form-group">
            <label>{{$t('cover.labelBookAuthor')}}（{{$t('cover.labelMaxCount', { count: 15 })}}）</label>
            <input type="text" :value="design.author" @change="changeAuthor" class="form-control" maxlength="15">
          </div>
          <div class="form-group" v-show="colorfulCovers.test(design.template)">
            <label>{{$t('cover.labelCoverSelect')}}</label>
            <color-list :coverColor="design.cover.color" @change="changeColor"></color-list>
          </div>
          <div class="form-group">
            <cover-type :value="design" @change="changeCover"/>
          </div>
        </template>
        <template v-if="activeTab === 'typeset'">
          <typeset-type :typeset="design.typeset" @change="changeTypeset"/>
        </template>
        <template v-if="activeTab === 'insert'">
          <insert-page :insert="design.insertPage" @change="changeInsert"/>
        </template>
      </div>
    </div>
    <div class="loading-content" v-else>
      <div class="loading-block text-center">
        <div class="loading-icon"></div>
        <p class="text-mini text-muted mt-1">
          <strong>{{$t('cover.loading')}}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CoverType from './CoverType.vue'
import TypesetType from './TypesetType.vue'
import ColorList from './ColorList.vue'
import api from 'src/api/'
import config from 'src/app.config'
import generateCover from 'src/_utils/generateCover'
import { mapGetters } from 'vuex'
import CoverHolder from '../../../components/CoverHolder'
import InsertPage from './InsertPage'

const design = {
  author: '',
  title: '',
  typeset: 'a5-1',
  template: 'cover-psb-1', // 封面模板样式，
  cover: {
    color: '#ffffff',
    imageUrl: ''
  }
}
export default {
  name: 'cover',
  components: {
    CoverType,
    TypesetType,
    ColorList,
    CoverHolder,
    InsertPage
  },
  data () {
    return {
      design: Object.assign({}, design),
      coverHeight: 141.1,
      activeTab: 'cover',
      showActionSheet: false,
      currentContent: {},
      colorfulCovers: config.colorfulCovers,
      plainCover: config.plainCover,
      swiperOption: {
        spaceBetween: 50
      },
      chapters: null,
      dataLoaded: false,
      templates: {
        'a5-1': 'https://static.ipastbook.com/assets/images/A5-1-simple.jpg',
        'a5-2': 'https://static.ipastbook.com/assets/images/A5-2-simple.jpg',
        'a4-1': 'https://static.ipastbook.com/assets/images/A4-1-simple.jpg',
        'a4-2': 'https://static.ipastbook.com/assets/images/A4-1-child.jpg'
      }
    }
  },
  created () {
    let {
      bid,
      item
    } = this.$route.query
    bid = this.$route.params.bid || bid
    item && (this.activeTab = item)
    if (!bid) {
      this.$toast({
        message: this.$t('cover.toastCoverError')
      })
      return
    }
    this.fetchBook(bid)
  },
  async beforeRouteLeave (to, from, next) {
    await this.saveCoverDesign(false)
    next()
  },
  computed: {
    ...mapGetters(['language']),
    tabList () {
      return [
        {
          name: 'cover',
          label: 'cover.tabCover',
          icon: 'book'
        },
        {
          name: 'typeset',
          label: 'cover.tabTypeset',
          icon: 'th'
        },
        {
          name: 'insert',
          label: 'cover.tabInsert',
          icon: 'bookmark'
        }
      ]
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    currentImage () {
      if (!this.dataLoaded) return ''
      if (this.activeTab !== 'typeset') {
        return generateCover({
          design: this.design,
          chapters: this.chapters
        })
      }
      return this.templates[this.design.typeset] || ''
    },
    insertPages () {
      const pages = []
      if (!this.dataLoaded) return pages
      const year = (new Date()).getFullYear()
      const codeName = this.design.insertPage || 'en'
      for (let i = 1; i <= 12; i++) {
        pages.push(`https://canvas.xinshu.me/generate/insert-${codeName}?year=${year}&month=${i}`)
      }
      return pages
    },
    previewImage () {
      return generateCover({
        design: this.design,
        chapters: this.chapters,
        size: 1920
      })
    }
  },
  methods: {
    fetchBook (bid) {
      return api.fetchBook(bid).then(data => {
        if (!data || data.errors) {
          this.$toast({
            message: this.$t('cover.toastCoverLoadFailed'),
            position: 'bottom'
          })
          return
        }
        let {
          currentChapters,
          design,
          typeset
        } = data
        if (typeset.includes('tweet')) {
          typeset = typeset.includes('waterfall') ? 'a5-1' : 'a5-2'
        }

        Object.keys(config.replaceColor).map((item) => {
          if (item === design.cover.color.toLowerCase()) {
            design.cover.color = config.replaceColor[item]
          }
        })
        design.typeset = typeset
        this.chapters = currentChapters
        this.design = design
        this.dataLoaded = true
        return Promise.resolve(design)
      })
    },
    changeTitle (e) {
      this.design.title = e.target.value
      this.saveCoverDesign()
    },
    changeAuthor (e) {
      this.design.author = e.target.value
      this.saveCoverDesign()
    },
    changeCover (value) {
      this.design = value
      this.saveCoverDesign()
    },
    changeTypeset (name) {
      this.design.typeset = name
      if (/a4-2$/i.test(name)) {
        // A4 童趣版强制选择插页
        this.design.insertPage = 'child'
      }
      this.saveCoverDesign()
    },
    changeColor (color) {
      this.design.cover.color = color
      this.saveCoverDesign()
    },
    changeInsert (insert) {
      this.design.insertPage = insert
      this.saveCoverDesign()
    },
    saveCoverDesign (notify = true) {
      if ((this.design.author || this.design.title) && this.design.template && this.design.cover.color) {
        const bid = this.$route.params.bid || this.$route.query.bid
        return api.updateCoverDesign(bid, this.design).then(data => {
          if (!data || data.errors) {
            this.$toast({
              message: this.$t('cover.toastCoverUpdateError'),
              position: 'bottom'
            })
          }
          if (notify) {
            this.$toast({
              message: this.$t('text.modified'),
              position: 'bottom',
              duration: 1000
            })
          }
        })
      }
    },
    setActiveTab (item) {
      this.activeTab = item.name
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          item: item.name
        }
      })
    },
    updateDesign (content) {
      this.showActionSheet = false
      switch (content.type) {
        case 'template':
          this.design.template = content.content.template
          this.design.cover.color = content.content.color
          break
        case 'typeset':
          this.design.typeset = content.content.content
          break
        case 'title':
          this.design.title = content.content.title
          this.design.author = content.content.author
          break
      }
      this.saveCoverDesign()
    }
  }
}
</script>

<style scoped lang="scss">
.cover-page {
  padding: 0;
  margin-top: 2rem;

  .cover-title {
    overflow: hidden;
  }

  :deep(.style-tag) {
    position: absolute;
    top: 8px;
    left: 0;
    width: 2.5em;
    line-height: 1.8;
    border-radius: 0 100px 100px 0;
    background-color: $el-color-primary-hover;
    color: white;
    font-size: 12px;
    text-align: center;
    z-index: 1;

    &.primary {
      background-color: $el-color-primary;
    }
  }

  .cover-holder {
    border-radius: 6px;
  }

  .swiper-slide {
    padding: 5px;
  }

  .cover-title {
    position: relative;
    padding-bottom: 8px;
    margin-bottom: 24px;
    line-height: 1;

    & > span {
      display: inline-block;
      height: 1em;
      width: 4px;
      border-radius: 4px;
      background-color: $el-color-primary;
    }
  }

  .cover-wrap {
    text-align: center;

    .cover-img {
      position: relative;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 36px !important;
      @media (max-width: 990px) {
        width: 50%;
      }

      @media (max-width: 767px) {
        width: 84%;
      }
      background-color: rgba(255, 255, 255, .5);
      box-shadow: $dp-3;

      .cover-img-frame {
        width: 100%;
        padding-bottom: 141.4%;
        background-color: #eeeeee;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;

        &[lazy=loading] {
          top: 50%;
          left: 50%;
          width: 54px;
          margin-top: -27px;
          margin-left: -27px;
        }

        &[lazy=error] {
          opacity: 0;
        }
      }

      .dimmer {
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
    }
  }

  .cover-bottom-option {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 56px;
    width: 100%;
    border-top: 1px solid #eee;
    background-color: white;
    display: flex;
    @media (min-width: 768px) {
      display: none;
    }

    > div {
      flex: 1;
      text-align: center;

      p {
        margin: 0;
        line-height: 1;
        font-size: 14px;
      }
    }

    .icon {
      font-size: 24px;
    }
  }

  .translate-down-enter-active {
    transition: all .25s;
  }

  .translate-down-leave-active {
    transition: all .25s ease-in;
    display: none;
  }

  .translate-down-enter, .translate-down-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateY(30px);
  }
}
</style>
